import { mockRequest } from "@/entities/mock";
import { apiRequest } from "@/api";
import { ENDPOINTS } from "@/api/endpoints";
import type {
  IMorningReport,
  IReportListApiItem,
  IReportListItem,
  ISummaryDetail,
  ISummaryListResponse,
} from "./statistics.types";

const MOCK_MORNING_REPORT: IMorningReport = {
  date: "13.05.2026",
  sending: 123555,
  clicks: 7900,
  orders: 1646,
  income: 789100,
  ctr: 3.25,
};

export async function fetchMorningReport(): Promise<IMorningReport> {
  return mockRequest<IMorningReport>(MOCK_MORNING_REPORT);
}

export type FetchSummaryListParams = {
  size?: number;
  page?: number;
  dateFrom?: string;
  dateTo?: string;
};

export async function fetchSummaryList(
  params: FetchSummaryListParams = {},
): Promise<ISummaryListResponse> {
  const { size = 20, page = 0, dateFrom, dateTo } = params;
  const [data, error] = await apiRequest<ISummaryListResponse>({
    method: "GET",
    path: ENDPOINTS.getSummaryList,
    queries: {
      size,
      page,
      ...(dateFrom ? { dateFrom } : {}),
      ...(dateTo ? { dateTo } : {}),
    },
  });
  if (error) throw new Error(error);
  return data;
}

export async function fetchSummaryById(id: number): Promise<ISummaryDetail> {
  const [data, error] = await apiRequest<ISummaryDetail>({
    method: "GET",
    path: ENDPOINTS.getSummaryById(id),
  });
  if (error) throw new Error(error);
  return data;
}

export async function fetchReports(): Promise<IReportListItem[]> {
  const [data, error] = await apiRequest<IReportListApiItem[]>({
    method: "GET",
    path: ENDPOINTS.getReportList,
  });
  if (error) throw new Error(error);
  return (data ?? [])
    .filter((item) => item.type === 1)
    .map((item) => ({
      id: item.id,
      name: item.name,
      mode: "Тип отправки",
      date: "21.03.2026",
      route: "",
      providerCount: 1,
      createdDate: "21.03.2026 13:32:10",
    }));
}
